import { getApiUrl } from '../config/api';
import {
  boundsFromCenter,
  boundsFromNominatim,
  normalizeBounds,
  zoomForBounds,
} from './mapSearchArea';

export const fetchSearchPlace = async (query) => {
  const q = String(query || '').trim();
  if (!q) return null;

  try {
    const res = await fetch(getApiUrl(`/api/geocode/search?q=${encodeURIComponent(q)}`));
    const data = await res.json();
    if (!data?.success || data.lat == null || data.lng == null) return null;

    const center = { lat: Number(data.lat), lng: Number(data.lng) };
    let bounds = boundsFromNominatim(data.boundingbox);
    if (!bounds) bounds = boundsFromCenter(center.lat, center.lng, 18);
    bounds = normalizeBounds(bounds);

    return {
      center,
      bounds,
      label: data.city || data.displayName || q,
      displayName: data.displayName || q,
      zoom: zoomForBounds(bounds),
    };
  } catch {
    return null;
  }
};

export const reverseGeocodeCenter = async (lat, lng) => {
  try {
    const res = await fetch(
      getApiUrl(`/api/geocode/reverse?lat=${lat}&lon=${lng}`)
    );
    const data = await res.json();
    if (!data?.success) return null;
    return {
      label: data.city || data.displayName || data.locality || null,
      displayName: data.displayName || null,
      city: data.city || null,
    };
  } catch {
    return null;
  }
};

/** Build map place object from /api/search searchPlace payload */
export const placeFromApiSearchPlace = (apiPlace, fallbackLabel = '') => {
  const centerRaw = apiPlace?.center;
  if (!centerRaw || centerRaw.lat == null || centerRaw.lng == null) return null;

  const center = { lat: Number(centerRaw.lat), lng: Number(centerRaw.lng) };
  if (!Number.isFinite(center.lat) || !Number.isFinite(center.lng)) return null;

  let bounds = boundsFromNominatim(apiPlace?.boundingbox);
  if (!bounds && apiPlace?.bounds) {
    bounds = normalizeBounds(apiPlace.bounds);
  }
  if (!bounds) bounds = boundsFromCenter(center.lat, center.lng, 18);
  bounds = normalizeBounds(bounds);

  const label = String(apiPlace.label || apiPlace.city || fallbackLabel || '').trim();

  return {
    center,
    bounds,
    label: label || fallbackLabel,
    displayName: label || fallbackLabel,
    zoom: zoomForBounds(bounds),
  };
};
